<template>
  <div class="complete-registration">
    <v-row align="center">
      <v-col class="text-center">
        <v-img src="../assets/2026/header.png" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h1 class="mb-4">Ut oh!</h1>
        <p>It looks like something went wrong trying to process your donation. No worries, click the button below to try again!</p>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <v-btn color="#A9421B" depressed block dark x-large @click="next">Let's try that again</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Cancel',

  data() {
    return {
      checkoutLink: null,
    }
  },

  computed: {
  },

  methods: {
    async next() {
      this.$router.push({ name: 'JoinRoute' })
    }
  },

  beforeMount() {
    this.$store.dispatch('checkForMember')
  }


}
</script>

<style lang="scss">

</style>